const getEnvFromHostname = (): string => {
  const { hostname } = window.location;
  if (hostname.includes('localhost') || hostname.includes('dev.') || hostname.includes('.local')) {
    return 'local';
  }

  if (hostname.includes('raceroster.com')) {
    return 'ue1live';
  }
  const [, , envName] = /([a-zA-Z0-9]*\.){0,}([a-zA-Z0-9]*)\.rostrr\.net$/.exec(hostname) || [];

  return envName ?? 'unknown';
};

export default getEnvFromHostname;
